// extracted by mini-css-extract-plugin
module.exports = {"iconDropdown":"_3lw0oadG8zqAN4ICZWeqgo"};